import type { JSX } from 'react'

import { TopNumber3SC } from './TopNumbers.styled'

export const Top3 = (): JSX.Element => (
  <TopNumber3SC
    width='127'
    height='195'
    viewBox='0 0 127 195'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M95.25 93.1667C105.116 97.8611 112.829 104.361 118.39 112.667C124.13 120.792 127 130.09 127 140.562C127 151.215 123.951 160.694 117.852 169C111.932 177.306 103.591 183.715 92.8284 188.229C82.0657 192.743 69.6886 195 55.697 195C36.1448 195 17.5791 189.854 0 179.562V150.042H1.07627C19.1935 162.681 37.1314 169 54.8898 169C67.6257 169 77.7606 166.292 85.2945 160.875C93.0078 155.278 96.8644 147.875 96.8644 138.667C96.8644 128.917 92.5593 121.062 83.9492 115.104C75.339 109.146 63.6794 106.167 48.9703 106.167H37.4004V80.9792H48.9703C62.9619 80.9792 73.8143 78.5417 81.5275 73.6667C89.4202 68.6111 93.3665 61.6597 93.3665 52.8125C93.3665 44.5069 89.9583 38.0069 83.142 33.3125C76.5049 28.6181 67.3566 26.2708 55.697 26.2708C47.8044 26.2708 39.9117 27.4444 32.0191 29.7917C24.3058 32.1389 15.7853 36.0208 6.45763 41.4375H5.38136V13.2708C21.8842 4.42361 39.1942 0 57.3114 0C70.4061 0 81.8863 2.07638 91.7521 6.22915C101.618 10.2014 109.242 15.8889 114.623 23.2917C120.184 30.6944 122.964 39.3611 122.964 49.2917C122.964 58.8611 120.542 67.4375 115.699 75.0208C110.856 82.6042 104.04 88.6528 95.25 93.1667Z'
      fill='url(#paint0_linear_5096_100048)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100048'
        x1='-19.911'
        y1='3.01302'
        x2='167.111'
        y2='169.644'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber3SC>
)
